import { Box, IconButton, Flex, Icon, Text } from '@chakra-ui/react';
import { useGetBluePrintQuery } from '@/store/query/blueprint';
import { ChevronLeft } from 'react-iconly';
import { useSteps } from 'react-step-builder';
import { Loader } from '@/design-system/loader';
import { XIcon } from '@heroicons/react/outline';

import { Metrics } from './metrics';
import { Stats } from './stats';
import { Steps } from './steps';

const Header = ({ blueprint = {}, onClose = () => {} }) => {
  const { prev } = useSteps();

  return (
    <Flex
      height="80px"
      borderBottom="1px"
      borderBottomColor="#E5E5E5"
      alignItems="center"
      px="24px"
    >
      <Flex flex="1" alignItems="center">
        <Box pos="relative" top="2px" onClick={prev} cursor="pointer">
          <Icon as={ChevronLeft} set="light" width="20px" height="20px" />
        </Box>
        <Text
          color="#0043CE"
          textDecor="underline"
          fontSize="14px"
          ml="4px"
          cursor="pointer"
          fontWeight="medium"
          onClick={prev}
        >
          Create Flow
        </Text>
        <Box ml="8px">/</Box>
        <Text ml="4px" fontWeight="medium">
          {blueprint?.name}
        </Text>
      </Flex>
      <Box>
        <>
          {blueprint?.from_kula ? (
            <Box
              as="span"
              bg="#E8DAFF"
              color="#6929C4"
              borderRadius="12px"
              p="5px 16px"
              fontWeight="semiBold"
              fontSize="12px"
              mr="4px"
            >
              Kula
            </Box>
          ) : (
            <Box
              fontWeight="semiBold"
              fontSize="12px"
              as="span"
              bg="#E8DAFF"
              color="#6929C4"
              borderRadius="12px"
              p="5px 16px"
              mr="4px"
            >
              Org
            </Box>
          )}
        </>
        <>
          {blueprint?.tag_names?.length > 0 &&
            blueprint?.tag_names?.map((tag) => (
              <Box
                fontWeight="semiBold"
                fontSize="12px"
                as="span"
                bg="#E7FFFE"
                color="#00736C"
                borderRadius="12px"
                p="5px 16px"
                mr="4px"
              >
                {tag}
              </Box>
            ))}
        </>
        <IconButton
          variant="icon"
          ml="16px"
          onClick={onClose}
          icon={<Icon as={XIcon} width="16px" height="16px" />}
        />
      </Box>
    </Flex>
  );
};

export const BlueprintDetails = ({ blueprint = {}, onClose = () => {} }) => {
  const { data, isLoading } = useGetBluePrintQuery(
    {
      blueprintId: blueprint?.id,
    },
    { skip: !blueprint?.id }
  );

  return (
    <Flex flexDir="column" height="inherit">
      <Header blueprint={blueprint} onClose={onClose} />
      <Flex flex="1" height="calc(100% - 80px)">
        <Box flex="1">
          {isLoading ? (
            <Flex
              justifyContent="center"
              alignItems="center"
              height="calc(100% - 70px)"
            >
              <Loader />
            </Flex>
          ) : (
            <>
              <Stats blueprint={data} />
              <Steps blueprint={data} />
            </>
          )}
        </Box>
        <Box w="100px" borderLeft="1px" borderColor="border-color">
          <Metrics blueprint={data} />
        </Box>
      </Flex>
    </Flex>
  );
};
